/* eslint-disable @typescript-eslint/no-explicit-any -- U2000Input* form handlers */
import type { TFunction } from 'i18next';
import U2000InputText from '../../../u2000Core/components/formControls/input/U2000InputText';
import U2000Label from '../../../u2000Core/components/formControls/label/U2000Label';
import { U2000FormStateEnumEditMode, U2000FormStateEnumState } from '../../../u2000Core/reducer/formReducer/U2000FormState';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { NS } from '../../U3303';
import type { U3303HolidayYearFormRow } from '../../U3303Service';
import U3303HolidayDaysSection from './U3303HolidayDaysSection';

interface U3303HolidayYearBodyProps {
  formStateHandlers: U2000FormStateHandlers<U3303HolidayYearFormRow>;
  t: TFunction;
}

function U3303HolidayYearBody({ formStateHandlers, t }: U3303HolidayYearBodyProps) {
  const isCreate = formStateHandlers.getFormEditMode() === U2000FormStateEnumEditMode.ADD;
  const yearReadonly =
    formStateHandlers.getFormState() === U2000FormStateEnumState.READ || !isCreate;

  return (
    <div className="space-y-8 p-2">
      <div className="space-y-4">
        <h3 className="text-base font-semibold text-gray-900">{t('lblSectionYear', { ns: NS })}</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex max-w-xs min-w-0 flex-col gap-1.5">
            <U2000Label htmlFor="year" label={t('lblYear', { ns: NS })} required={isCreate} />
            <U2000InputText
              hideLabel
              formStateHandlers={formStateHandlers as any}
              fieldName="year"
              label={t('lblYear', { ns: NS })}
              type="number"
              readonly={yearReadonly}
              required={isCreate}
            />
          </div>
        </div>
      </div>

      <U3303HolidayDaysSection formStateHandlers={formStateHandlers} t={t} />
    </div>
  );
}

export default U3303HolidayYearBody;
